import Vue from 'vue'
import Router from 'vue-router'
import VueRouter from 'vue-router'
// 解决ElementUI导航栏中的vue-router在3.0版本以上重复点菜单报错问题
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}


Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/home',
      name: '首页',
      component: () => import('../views/home.vue'),
    },
    {
      path: '/home/advice',
      name: '反馈',
      component: () => import('../views/advice.vue')
    }, {
      path: '/home/class_content',
      name: '课程内容',
      component: () => import('../views/my_class.vue')
    },
    {
      path: '/home/study',
      name: '答题',
      component: () => import('../views/study.vue'),
    },
    {
      path: '/',
      name: '登录',
      component: () => import('../views/login.vue')
    },
    {
      path: '/payment',
      name: '支付',
      component: () => import('../views/payment.vue')
    },
    {
      path: '/user_agreement',
      name: '用户协议',
      component: () => import('../views/agreement/userAgreement.vue')
    },
    {
      path: '/privacy_policy',
      name: '隐私政策',
      component: () => import('../views/agreement/privacyPolicy.vue')
    },
    {
      path: '/home/exercises',
      name: '习题',
      component: () => import('../views/exercises/index.vue')
    },
    {
      path: '/more_combination',
      name: '更多组合',
      component: () => import('../views/moreCombination.vue')
    },
    {
      path: '/try',
      name: 'try',
      component: () => import('../views/try.vue')
    },
  ],
  mode: 'history',
})
router.beforeEach((to, from, next) => {
  if (to.path === "/") {
    //如果用户信息存在则往下执行。
    next()
  } else if (to.path === "/user_agreement") {
    next()
  } else if (to.path === "/privacy_policy") {
    next()
  } else {
    let isLogin = window.localStorage.getItem('token');
    let openid = window.localStorage.getItem('openid');
    // if (!isLogin && !openid) {
    //   next("/")
    // } else {
    //   next()

    // }
  }
  next()
})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js